import { useAuth } from '@/hooks/useAuth';
import { Permission } from '@hr-outsourcing/shared';
import { SeatStatus } from '@/services/seatAssignmentService';

export type RestrictionReason = SeatStatus.RESERVED | SeatStatus.UNASSIGNED | null;

export interface AccessRestriction {
  isRestricted: boolean;
  restrictionReason: RestrictionReason;
}

export function useAccessRestriction(): AccessRestriction {
  const { user, hasPermission } = useAuth();

  // SuperAdmin and company-type users have no seat concept — never restricted.
  // Users with account-settings:manage permission can always access billing/payment,
  // even when RESERVED, so they can resolve their own lockout.
  if (!user || user.isSuperAdmin || user.isCompany || hasPermission(Permission.ACCOUNT_SETTINGS_MANAGE)) {
    return { isRestricted: false, restrictionReason: null };
  }

  const seatStatus = user.seatStatus;

  if (seatStatus === SeatStatus.ACTIVE) {
    return { isRestricted: false, restrictionReason: null };
  }

  // RESERVED or null (unassigned) → restricted
  const restrictionReason: RestrictionReason =
    seatStatus === SeatStatus.RESERVED ? SeatStatus.RESERVED : SeatStatus.UNASSIGNED;

  return { isRestricted: true, restrictionReason };
}
